/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:1a230389-5fef-4a86-bfe2-d2321a57c17b",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_ZyasivxUX",
    "aws_user_pools_web_client_id": "61eetcj4f0iis442hmsqn6bqr4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "monitoring-storage-greenarc130639-staging",
    "aws_user_files_s3_bucket_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://wdoclrf635gljpi4zlsi6moeaa.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-koj3dtjdsjdezngu4wcunvzeom"
};


export default awsmobile;
